import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=4aa23914"
import script from "./collection.ts?vue&type=script&lang=js&external"
export * from "./collection.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports